import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { Popover, Switch, Tooltip } from 'antd';
import { NodeToolbar, Position } from '@xyflow/react';
import styles from './index.module.scss';

const BASE_URL = 'https://photostudio-ai-oss.arcsoft.com.cn//photostudio-opshub/FreeCanvas';
const START_ICON = `${BASE_URL}/start.svg`;
const COPY_ICON = `${BASE_URL}/copy.svg`;
const DOWNLOAD_ICON = `${BASE_URL}/download.svg`;
const SELECT_FOCUS_ICON = `${BASE_URL}/selectFocus.svg`;
const TEMPLATE_ICON = `${BASE_URL}/template.svg`;

const GroupActionToolbar = ({
    visible = false,
    nodeIds = [],
    items = [],
    position = null,
}) => {
    if (!visible || !nodeIds?.length || !items?.length) return null;

    const toolbarContent = (
        <div
            className={styles.toolbar}
            data-free-canvas-export-ignore="true"
            style={position ? {
                position: 'fixed',
                left: position.x,
                top: position.y,
                transform: 'translate(-50%, -100%)',
                zIndex: 60,
            } : undefined}
            onMouseDown={(event) => event.stopPropagation()}
        >
            {items.map((item, index) => {
                const icon = ({
                    start: START_ICON,
                    copy: COPY_ICON,
                    download: DOWNLOAD_ICON,
                    focus: SELECT_FOCUS_ICON,
                    template: TEMPLATE_ICON,
                }[item.icon] || COPY_ICON);
                const actionButton = (
                    <button
                        type="button"
                        className={`${styles.action} ${item.disabled ? styles.actionDisabled : ''}`}
                        disabled={item.disabled || item.loading}
                        onClick={(event) => {
                            event.stopPropagation();
                            if (item.disabled || item.loading) return;
                            item.onClick?.();
                        }}
                    >
                        {item.loading ? (
                            <LoadingOutlined className={`${styles.icon} ${styles.iconLoading}`} />
                        ) : (
                            <img src={icon} alt="" width={16} height={16} className={styles.icon} draggable={false} />
                        )}
                        <span className={styles.label}>{item.label}</span>
                    </button>
                );
                const buttonContent = item.popover ? (
                    <Popover
                        trigger="hover"
                        placement="top"
                        overlayClassName={styles.toolbarPopover}
                        content={(
                            <div
                                className={styles.popoverContent}
                                onMouseDown={(event) => event.stopPropagation()}
                                onClick={(event) => event.stopPropagation()}
                            >
                                <div className={styles.popoverRow}>
                                    <span className={styles.popoverTitle}>{item.popover.title}</span>
                                    <Switch
                                        size="small"
                                        checked={!!item.popover.checked}
                                        onChange={item.popover.onChange}
                                        onClick={(checked, event) => event?.stopPropagation?.()}
                                    />
                                </div>
                                {item.popover.hint ? (
                                    <div className={styles.popoverHint}>{item.popover.hint}</div>
                                ) : null}
                            </div>
                        )}
                    >
                        <span className={styles.popoverTrigger}>{actionButton}</span>
                    </Popover>
                ) : actionButton;

                return (
                    <React.Fragment key={item.key}>
                        {item.tooltip ? (
                            <Tooltip title={item.tooltip} placement="top">
                                {buttonContent}
                            </Tooltip>
                        ) : buttonContent}
                        {index < items.length - 1 ? <span className={styles.divider} /> : null}
                    </React.Fragment>
                );
            })}
        </div>
    );

    if (position) {
        return toolbarContent;
    }

    return (
        <NodeToolbar
            nodeId={nodeIds.length === 1 ? nodeIds[0] : nodeIds}
            isVisible
            position={Position.Top}
            offset={12}
            align="center"
        >
            {toolbarContent}
        </NodeToolbar>
    );
};

export default GroupActionToolbar;
